import { render, staticRenderFns } from "./ProjectDetail.vue?vue&type=template&id=d027541a&scoped=true&"
import script from "./ProjectDetail.vue?vue&type=script&lang=js&"
export * from "./ProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetail.vue?vue&type=style&index=0&id=d027541a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d027541a",
  null
  
)

export default component.exports